import { Field, isRequired } from '@rainbow-modules/forms';
import { ModalContent } from './styled';
import { StyledInput, StyledGoogleAddressLookup, StyledTextarea } from '../styled';

const Fields = () => (
    <ModalContent>
        <Field
            name="name"
            component={StyledInput}
            label="Location Name"
            placeholder="Enter the location name"
            validate={isRequired()}
            labelAlignment="left"
            borderRadius="semi-square"
            required
        />
        <Field
            name="address"
            component={StyledGoogleAddressLookup}
            label="Location Address"
            placeholder="Enter the location address"
            validate={isRequired()}
            labelAlignment="left"
            borderRadius="semi-square"
            countries={['us']}
            required
        />
        <Field
            name="description"
            component={StyledTextarea}
            label="Description"
            placeholder="Enter a description for this location (optional)"
            labelAlignment="left"
            borderRadius="semi-square"
            rows={3}
        />
    </ModalContent>
);

export default Fields;
